import { useErrorStore } from "@/store/teacher/error_store"
const handleTeacherError = (e) => {
  if (e.response) {

    let code: any = ""
    let title: string = "エラーが発生しました"
    let text: string = "エラーが発生しました。時間を置いて再度お試しください。"

    if (e.response.status == 500) {
      code = e.response.status
    } else if (e.response.status == 503) {
      code = e.response.status
    } else if (e.response.data.error) {
      // バックエンドで明示的に指定したエラー
      code = e.response.data.error.code
      title = e.response.data.error.message
      // detail がない場合は Sentry でエラー捕捉できる段階になる日までは、デフォルトのエラー本文を設定
      text = e.response.data.error.data?.detail ?? text
    } else {
      code = e.response.status
    }
    const errorStore = useErrorStore()
    errorStore.saveTeacherError(
      {
        "code": code,
        "title": title,
        "text": text,
      }
    )
  }
  else {
    console.log(e)
    throw e
  }
}
export default handleTeacherError
